const modOneData = {
  module: 1,
  category: 'Frontend Basics',
  days: [
    {
      link: "https://repl.it/@HannahHudson1/AdventDay1#index.js",
      emoji: "🎁"
    },
    {
      link: "https://codepen.io/hannahhch/pen/OJXGpxJ",
      emoji: "✉️"
    },
    {
      link: "https://gist.github.com/Kalikoze/0544683112bd0c0381f634c8cdda6c42",
      emoji: "⛷️"
    },
    {
      link: "https://github.com/turingschool-examples/cookie-comp",
      emoji: "🍪"
    },
    {
      link: "https://repl.it/@HannahHudson1/Advent5#index.js",
      emoji: "🥳"
    },
    {
      link: "https://codepen.io/hannahhch/pen/QWEPeKb",
      emoji: "❄️"
    },
    {
      link: "https://codepen.io/Kalikoze/pen/abXVrpK",
      emoji: "🕛"
    },
    {
      link: "https://repl.it/@HannahHudson1/Advent8",
      emoji: "🥋"
    },
    {
      link: "https://gist.github.com/Kalikoze/5c51aae50247fe03de0edc591159b737",
      emoji: "☃️"
    },
    {
      link: "https://github.com/turingschool-examples/winter-mad-libs",
      emoji: "📝"
    }
  ]
};

export default modOneData;
